(function () {
  'use strict';

  function moneyFromCents(cents, fallback) {
    if (fallback) return fallback;
    var n = Number(cents) / 100;
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    try {
      if (typeof window.openStrawberryBag === 'function') {
        window.openStrawberryBag();
        return;
      }
    } catch (e) {}
    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
        window.kachingCartApi.refreshCart();
      }
    } catch (e) {}

    var trigger =
      document.querySelector('[data-kaching-cart-open]') ||
      document.querySelector('a[href="#kaching-cart"]') ||
      document.querySelector('.kaching-cart-icon, .kaching-cart__icon, #kaching-cart-icon') ||
      document.querySelector('#kaching-cart .kaching-cart__header-close');

    var drawer = document.querySelector('#kaching-cart, kaching-cart');
    if (drawer) {
      drawer.classList.add('is-open', 'active', 'open');
      drawer.setAttribute('open', '');
      document.documentElement.classList.add('kaching-cart-open');
    }

    var cartBtn =
      document.querySelector('[aria-controls="kaching-cart"]') ||
      document.querySelector('button[data-action="open-cart"]') ||
      document.querySelector('.header__icon--cart, .cart-icon-bubble, a[href="/cart"]');
    if (cartBtn && typeof cartBtn.click === 'function') {
      cartBtn.click();
    } else if (trigger && typeof trigger.click === 'function') {
      trigger.click();
    }
  }

  function atcButtons(root, satc) {
    var list = [];
    root.querySelectorAll('[data-clc-atc]').forEach(function (b) {
      list.push(b);
    });
    if (satc) {
      satc.querySelectorAll('[data-clc-atc]').forEach(function (b) {
        if (list.indexOf(b) === -1) list.push(b);
      });
    }
    return list;
  }

  function initRoot(root) {
    if (!root || root.dataset.clcReady === '1') return;
    root.dataset.clcReady = '1';

    var sid = root.getAttribute('data-section-id') || '';
    var variantId = root.getAttribute('data-variant-id');
    var sellingPlanId = root.getAttribute('data-selling-plan-id') || '';
    var otMoney = root.getAttribute('data-ot-money');
    var subMoney = root.getAttribute('data-sub-money');
    var compareMoney = root.getAttribute('data-compare-money');
    var savePct = root.getAttribute('data-save-pct') || '52';
    var brushUrl = root.getAttribute('data-brush-url') || '';
    var productId = root.getAttribute('data-product-id') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var skipGift = root.getAttribute('data-skip-gift') === '1';

    var plan = 'sub';
    var isAdding = false;
    // Bumped on each ATC so a prior background gift clean-up stops immediately.
    var giftCleanupEpoch = 0;

    function bundleNonce() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return 'kb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    function cartAdd(path, payload) {
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + path.replace(/^\//, ''), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      }).then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add to cart';
          throw new Error(msg);
        }
        return res.data;
      });
    }

    function readCart() {
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + 'cart.js', { cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw new Error('Could not verify your cart.');
        return r.json();
      });
    }

    // Prefer the in-page Kaching app block (deal JSON on this landing page).
    // Fall back to a PDP fetch only when those scripts are missing entirely.
    var subscriptionGiftBundle = null;
    var subscriptionGiftBundlePromise = null;

    function hasKachingDealData(scope) {
      var settingsNodes = scope.querySelectorAll('script.kaching-bundles-deal-block-settings');
      for (var i = 0; i < settingsNodes.length; i++) {
        try {
          var parsed = JSON.parse(settingsNodes[i].textContent);
          if (parsed && (parsed.dealBars || []).length) return true;
        } catch (e) {}
      }
      return false;
    }

    function parseSubscriptionGiftsFromScope(scope) {
      var settingsNodes = Array.prototype.slice.call(
        scope.querySelectorAll('script.kaching-bundles-deal-block-settings')
      );
      var settings = null;
      for (var i = 0; i < settingsNodes.length; i++) {
        try {
          settings = JSON.parse(settingsNodes[i].textContent);
          if (settings && (settings.dealBars || []).length) break;
        } catch (e) {}
      }
      if (!settings) throw new Error('The Kaching subscription offer is unavailable.');

      var bars = settings.dealBars || [];
      var bar = null;
      for (var b = 0; b < bars.length; b++) {
        var dealBar = bars[b];
        var hasSubGift = (dealBar.freeGifts || []).some(function (gift) {
          return gift.giftType === 'product' && gift.applyOnlyForSubscriptions;
        });
        if (hasSubGift) {
          bar = dealBar;
          break;
        }
      }
      if (!bar) bar = bars[0];
      if (!bar) throw new Error('No Kaching deal bar found for this product.');

      // Deal with no subscription gift is valid — ATC adds the product only.
      var gifts = (bar.freeGifts || []).filter(function (gift) {
        return gift.giftType === 'product' && gift.applyOnlyForSubscriptions;
      });

      var resolved = gifts.map(function (gift) {
        var giftProductId = String(gift.productGID || '').split('/').pop();
        var productNode = scope.querySelector(
          'script.kaching-bundles-product[data-product-id="' + giftProductId + '"]'
        );
        if (!productNode) throw new Error('The subscription gift is unavailable.');
        var giftProduct = JSON.parse(productNode.textContent);
        var choices = (giftProduct.variants || []).filter(function (variant) {
          if (!variant.availableForSale) return false;
          if (!gift.variantGIDs || !gift.variantGIDs.length) return true;
          return gift.variantGIDs.some(function (gid) {
            return String(gid).split('/').pop() === String(variant.id);
          });
        });
        if (choices.length !== 1) {
          throw new Error('Please select your subscription gift on the product page.');
        }
        return {
          giftId: gift.id,
          variantId: choices[0].id,
          quantity: gift.quantity || 1
        };
      });

      return {
        deal: settings.nanoId || settings.id,
        versionId: settings.versionId,
        marketId: settings.marketId,
        barId: bar.id,
        gifts: resolved
      };
    }

    function loadSubscriptionGifts() {
      if (subscriptionGiftBundle) return Promise.resolve(subscriptionGiftBundle);
      if (subscriptionGiftBundlePromise) return subscriptionGiftBundlePromise;

      var pageHasDeal = hasKachingDealData(root) || hasKachingDealData(document);
      var pageParseError = null;

      try {
        subscriptionGiftBundle = parseSubscriptionGiftsFromScope(root);
        return Promise.resolve(subscriptionGiftBundle);
      } catch (localErr) {
        pageParseError = localErr;
        try {
          subscriptionGiftBundle = parseSubscriptionGiftsFromScope(document);
          return Promise.resolve(subscriptionGiftBundle);
        } catch (docErr) {
          pageParseError = docErr;
        }
      }

      // Deal JSON is already on this page (even with no sub gift) — never PDP-fetch.
      if (pageHasDeal) {
        return Promise.reject(pageParseError || new Error('No subscription gift found for this offer.'));
      }

      if (!productHandle) {
        return Promise.reject(new Error('Missing product handle for Kaching gift.'));
      }
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      subscriptionGiftBundlePromise = fetch(
        rootPath + 'products/' + encodeURIComponent(productHandle),
        { credentials: 'same-origin' }
      )
        .then(function (r) {
          if (!r.ok) throw new Error('Could not load the Kaching subscription offer.');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          subscriptionGiftBundle = parseSubscriptionGiftsFromScope(doc);
          return subscriptionGiftBundle;
        })
        .catch(function (err) {
          subscriptionGiftBundlePromise = null;
          throw err;
        });
      return subscriptionGiftBundlePromise;
    }

    if (productHandle && !skipGift) {
      loadSubscriptionGifts().catch(function () {});
    }

    var CHK =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--green-600)" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
    var BENS = [
      ['Save ' + savePct + '% on every delivery', true],
      ['Never run out, consistent results guaranteed', false],
      ['Free shipping today', true],
      ['Pause, skip, or cancel anytime, zero commitment', false]
    ]
      .map(function (pair) {
        return (
          '<li class="ben' +
          (pair[1] ? ' hl' : '') +
          '">' +
          CHK +
          '<span>' +
          pair[0] +
          '</span></li>'
        );
      })
      .join('');
    var GIFT = skipGift
      ? ''
      : '<div class="giftrow"><img src="' +
        brushUrl +
        '" alt="FREE Body Brush" /><div class="t"><b>FREE Body Brush</b><span>For smooth areas only</span></div><div class="pr"><b>FREE</b><s>$15.00</s></div></div>';

    var swline = root.querySelector('#swline-' + sid) || root.querySelector('[id^="swline-"]');
    var pbox = root.querySelector('[data-plan-box]');
    var pbody = pbox ? pbox.querySelector('[data-plan-body]') : null;
    var satc = root.querySelector('#satc-' + sid) || root.querySelector('.satc');
    if (
      satc &&
      document.body.classList.contains('template-suffix-clc-ec-steroid-alt') &&
      satc.parentNode !== document.body
    ) {
      document.body.appendChild(satc);
    }
    var satcNow = (satc && satc.querySelector('[data-satc-now]')) || root.querySelector('[data-satc-now]');
    var satcWas = (satc && satc.querySelector('[data-satc-was]')) || root.querySelector('[data-satc-was]');

    function renderPlan() {
      var sub = plan === 'sub';
      if (!pbox || !pbody) return;
      pbox.classList.toggle('otp', !sub);
      var nameRow = pbox.querySelector('.name-row');
      if (nameRow) {
        nameRow.innerHTML =
          '<span class="plan-name">Single Bottle</span>' +
          (sub ? '<span class="save">' + savePct + '% OFF</span>' : '');
      }
      var supply = pbox.querySelector('.supply');
      if (supply) supply.textContent = sub ? 'Autoships Every Month' : '1-Month Supply';
      var price = pbox.querySelector('.price');
      if (price) {
        price.innerHTML =
          '<span class="p-now">' +
          (sub ? subMoney : otMoney) +
          '</span>' +
          (sub ? '<span class="p-was">' + compareMoney + '</span>' : '');
      }
      pbody.innerHTML = sub ? '<ul class="bens">' + BENS + '</ul>' + GIFT : '';
      var divline = pbox.querySelector('.divline');
      if (divline) divline.hidden = !sub;
      if (swline) swline.hidden = sub;

      root.querySelectorAll('[data-plan]').forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-plan') === plan);
      });

      if (satcNow) satcNow.textContent = sub ? subMoney : otMoney;
      if (satcWas) {
        satcWas.style.display = sub ? '' : 'none';
        satcWas.textContent = compareMoney;
      }
    }

    if (pbody) {
      pbody.innerHTML = '<ul class="bens">' + BENS + '</ul>' + GIFT;
    }

    function setPlan(next) {
      plan = next === 'sub' ? 'sub' : 'otp';
      renderPlan();
    }

    root.querySelectorAll('[data-plan]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setPlan(btn.getAttribute('data-plan'));
      });
    });
    if (swline) {
      swline.addEventListener('click', function () {
        if (plan !== 'sub') setPlan('sub');
      });
    }
    renderPlan();

    var track = root.querySelector('#track-' + sid) || root.querySelector('.track');
    var thumbs = root.querySelector('#thumbs-' + sid) || root.querySelector('.thumbs');
    var cbadge = root.querySelector('[data-cbadge], .cbadge');
    if (track && thumbs) {
      thumbs.innerHTML = '';
      var slides = Array.prototype.slice.call(track.children);
      slides.forEach(function (s, i) {
        var img = s.querySelector('img');
        if (!img) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'th' + (i === 0 ? ' on' : '');
        b.innerHTML = '<img src="' + img.getAttribute('src') + '" alt="" />';
        b.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
        thumbs.appendChild(b);
      });
      track.addEventListener(
        'scroll',
        function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          Array.prototype.forEach.call(thumbs.children, function (t, n) {
            t.classList.toggle('on', n === i);
          });
          if (cbadge) cbadge.style.opacity = i === 0 ? '1' : '0';
        },
        { passive: true }
      );
      if (cbadge) cbadge.style.opacity = '1';
    }

    var bb = root.querySelector('.bb');
    function updSatc() {
      if (!satc || !bb) return;
      satc.classList.toggle('on', bb.getBoundingClientRect().bottom < 8);
    }
    window.addEventListener('scroll', updSatc, { passive: true });
    window.addEventListener('resize', updSatc);
    if (bb && typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(
        function () {
          updSatc();
        },
        { threshold: [0, 0.01, 1] }
      );
      io.observe(bb);
    }
    updSatc();

    var promo = root.querySelector('[data-promo], .promo');
    var lastY = window.scrollY || 0;
    window.addEventListener(
      'scroll',
      function () {
        if (!promo) return;
        var y = window.scrollY || 0;
        if (y < 8) {
          promo.classList.remove('is-hidden');
        } else if (y > lastY + 4) {
          promo.classList.add('is-hidden');
        } else if (y < lastY - 4) {
          promo.classList.remove('is-hidden');
        }
        lastY = y;
      },
      { passive: true }
    );

    var faqBtn = root.querySelector('[data-faq-more]');
    var faqMore = root.querySelector('#faqMore-' + sid) || root.querySelector('.faq-more');
    if (faqBtn && faqMore) {
      faqBtn.addEventListener('click', function () {
        var on = faqMore.classList.toggle('on');
        faqBtn.textContent = on ? 'Show fewer questions' : 'Load more questions';
      });
    }

    var coaModal = root.querySelector('#coaModal-' + sid) || root.querySelector('.coa-ov');
    root.querySelectorAll('.coa-btn').forEach(function (btn) {
      btn.removeAttribute('onclick');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (coaModal) coaModal.classList.add('on');
      });
    });
    if (coaModal) {
      coaModal.removeAttribute('onclick');
      coaModal.addEventListener('click', function (e) {
        if (e.target === coaModal) coaModal.classList.remove('on');
      });
      coaModal.querySelectorAll('[aria-label="Close"], .coa-hd button').forEach(function (x) {
        x.removeAttribute('onclick');
        x.addEventListener('click', function () {
          coaModal.classList.remove('on');
        });
      });
    }

    function addToCart() {
      if (isAdding || !variantId) return;
      // Cancel any in-flight gift clean-up from a previous add.
      var cleanupEpoch = ++giftCleanupEpoch;
      function cleanupAlive() {
        return cleanupEpoch === giftCleanupEpoch;
      }
      isAdding = true;
      atcButtons(root, satc).forEach(function (b) {
        b.disabled = true;
        b.setAttribute('aria-busy', 'true');
      });

      function resetBusy() {
        isAdding = false;
        atcButtons(root, satc).forEach(function (b) {
          b.disabled = false;
          b.removeAttribute('aria-busy');
        });
      }

      function addOneTime() {
        var item = { id: Number(variantId), quantity: 1 };
        return cartAdd('cart/add.js', { items: [item] }).then(function () {
          openCart();
        });
      }

      function addSubscriptionOnly() {
        var giftVariantId = skipGift ? Number(root.getAttribute('data-gift-variant-id') || 0) : 0;
        var beforeGiftKeys = [];
        var beforeQtyByKey = {};

        function stripNewGifts() {
          if (!giftVariantId) return Promise.resolve();
          var started = Date.now();
          function pass() {
            if (!cleanupAlive()) return Promise.resolve();
            return readCart().then(function (cart) {
              if (!cleanupAlive()) return;
              var changes = (cart.items || []).filter(function (item) {
                return Number(item.variant_id || item.id) === giftVariantId;
              }).map(function (item) {
                if (beforeGiftKeys.indexOf(item.key) === -1) {
                  return { id: item.key, quantity: 0 };
                }
                var beforeQty = beforeQtyByKey[item.key] || 0;
                if (Number(item.quantity) > beforeQty) {
                  return { id: item.key, quantity: beforeQty };
                }
                return null;
              }).filter(Boolean);

              return changes
                .reduce(function (chain, change) {
                  return chain.then(function () {
                    if (!cleanupAlive()) return;
                    return cartAdd('cart/change.js', change);
                  });
                }, Promise.resolve())
                .then(function () {
                  if (!cleanupAlive()) return;
                  if (Date.now() - started < 1500) return sleep(200).then(pass);
                });
            });
          }
          return pass();
        }

        var start = giftVariantId
          ? readCart().then(function (cart) {
              (cart.items || []).forEach(function (item) {
                if (Number(item.variant_id || item.id) !== giftVariantId) return;
                beforeGiftKeys.push(item.key);
                beforeQtyByKey[item.key] = Number(item.quantity) || 0;
              });
            })
          : Promise.resolve();

        return start.then(function () {
          var item = { id: Number(variantId), quantity: 1, selling_plan: Number(sellingPlanId) };
          return cartAdd('cart/add.js', { items: [item] }).then(function () {
            openCart();
            // Strip EG brushes in the background so the bag isn't blocked.
            stripNewGifts().catch(function (err) {
              console.error('[clc-ec-page01ads] Gift strip failed', err);
            });
          });
        });
      }

      function sleep(ms) {
        return new Promise(function (resolve) {
          setTimeout(resolve, ms);
        });
      }

      function giftLines(cart, giftVariantIds) {
        return (cart.items || []).filter(function (item) {
          return giftVariantIds.indexOf(Number(item.variant_id || item.id)) !== -1;
        });
      }

      function giftQty(cart, giftVariantIds) {
        return giftLines(cart, giftVariantIds).reduce(function (sum, item) {
          return sum + (Number(item.quantity) || 0);
        }, 0);
      }

      // EG handled this add if total brush quantity rose (new line or qty bump).
      function waitForNewGift(giftVariantIds, beforeQty, timeoutMs) {
        var started = Date.now();
        function check() {
          return readCart().then(function (cart) {
            if (giftQty(cart, giftVariantIds) > beforeQty) return true;
            if (Date.now() - started >= timeoutMs) return false;
            return sleep(150).then(check);
          });
        }
        return check();
      }

      // Only undo brushes added for this ATC — never touch older gift units.
      // Stops if a newer ATC bumped giftCleanupEpoch (one clean-up at a time).
      function removeExtraGifts(giftVariantIds, beforeGiftKeys, beforeQtyByKey, keepNonce, allowedNewQty) {
        var started = Date.now();
        function isKeepGift(item) {
          try {
            var props = JSON.parse((item.properties && item.properties.__kaching_bundles) || '{}');
            return !!(props && props.gift && props.id === keepNonce);
          } catch (e) {
            return false;
          }
        }
        function pass() {
          if (!cleanupAlive()) return Promise.resolve();
          return readCart().then(function (cart) {
            if (!cleanupAlive()) return;
            var lines = giftLines(cart, giftVariantIds);
            var newcomers = lines.filter(function (item) {
              return beforeGiftKeys.indexOf(item.key) === -1;
            });
            var keep = newcomers.filter(isKeepGift);
            var protectKey = keep.length ? keep[0].key : null;
            var budget = allowedNewQty;
            var changes = [];

            if (protectKey) {
              // Theme gift present — restore pre-existing qtys and drop other newcomers.
              lines.forEach(function (item) {
                if (item.key === protectKey) return;
                if (beforeGiftKeys.indexOf(item.key) !== -1) {
                  var before = beforeQtyByKey[item.key] || 0;
                  if (Number(item.quantity) !== before) {
                    changes.push({ id: item.key, quantity: before });
                  }
                } else {
                  changes.push({ id: item.key, quantity: 0 });
                }
              });
            } else {
              // EG path: allow only `budget` new units (new lines or qty bumps).
              newcomers.forEach(function (item) {
                if (budget <= 0) {
                  changes.push({ id: item.key, quantity: 0 });
                  return;
                }
                var qty = Number(item.quantity) || 0;
                var keepUnits = Math.min(qty, budget);
                budget -= keepUnits;
                if (keepUnits <= 0) changes.push({ id: item.key, quantity: 0 });
                else if (keepUnits < qty) changes.push({ id: item.key, quantity: keepUnits });
              });
              lines.forEach(function (item) {
                if (beforeGiftKeys.indexOf(item.key) === -1) return;
                var before = beforeQtyByKey[item.key] || 0;
                var current = Number(item.quantity) || 0;
                var bump = Math.max(0, current - before);
                var keepBump = Math.min(bump, budget);
                budget -= keepBump;
                var target = before + keepBump;
                if (current !== target) changes.push({ id: item.key, quantity: target });
              });
            }

            return changes
              .reduce(function (chain, change) {
                return chain.then(function () {
                  if (!cleanupAlive()) return;
                  return cartAdd('cart/change.js', change);
                });
              }, Promise.resolve())
              .then(function () {
                if (!cleanupAlive()) return;
                if (Date.now() - started < 1500) return sleep(200).then(pass);
              });
          });
        }
        return pass();
      }

      function addSubscriptionWithGift() {
        return loadSubscriptionGifts().then(function (bundle) {
          // No free gift on this deal — plain subscription add (avoid tagging a Kaching bar).
          if (!(bundle.gifts || []).length) {
            return addSubscriptionOnly();
          }

          var nonce = bundleNonce();
          var mainProps = {
            deal: bundle.deal,
            pp: Number(productId) || undefined,
            main: true,
            id: nonce,
            bar: bundle.barId
          };
          if (bundle.versionId) mainProps.v = bundle.versionId;
          if (bundle.marketId) mainProps.market = bundle.marketId;

          var mainItem = {
            id: Number(variantId),
            quantity: 1,
            properties: {
              __kaching_bundles: JSON.stringify(mainProps)
            }
          };
          if (sellingPlanId) mainItem.selling_plan = Number(sellingPlanId);

          var giftItems = (bundle.gifts || []).map(function (gift) {
            var giftProps = {
              id: nonce,
              deal: bundle.deal,
              gift: gift.giftId
            };
            if (bundle.versionId) giftProps.v = bundle.versionId;
            return {
              id: Number(gift.variantId),
              quantity: gift.quantity,
              properties: {
                __kaching_bundles: JSON.stringify(giftProps)
              }
            };
          });
          var giftVariantIds = giftItems.map(function (item) {
            return Number(item.id);
          });
          var giftAddQty = giftItems.reduce(function (sum, item) {
            return sum + (Number(item.quantity) || 0);
          }, 0) || 1;
          var giftWarning = '';
          var beforeGiftKeys = [];
          var beforeQtyByKey = {};
          var beforeQty = 0;

          return readCart()
            .then(function (before) {
              giftLines(before, giftVariantIds).forEach(function (item) {
                beforeGiftKeys.push(item.key);
                beforeQtyByKey[item.key] = Number(item.quantity) || 0;
              });
              beforeQty = giftQty(before, giftVariantIds);
              return cartAdd('cart/add.js?kaching_bundles=true&partial=true', { items: [mainItem] });
            })
            .then(function () {
              if (!giftItems.length) return;
              return waitForNewGift(giftVariantIds, beforeQty, 1200)
                .then(function (egAdded) {
                  if (egAdded) return;
                  return cartAdd('cart/add.js?kaching_bundles=true&partial=true', { items: giftItems }).then(
                    function () {
                      return readCart().then(function (after) {
                        var paid = giftLines(after, giftVariantIds).filter(function (item) {
                          return item.final_line_price !== 0;
                        });
                        if (paid.length) {
                          giftWarning =
                            'Your subscription was added, but the free gift discount was not applied. Please review your cart.';
                        }
                      });
                    }
                  );
                })
                .catch(function (giftErr) {
                  console.error('[clc-ec-page01ads] Free gift add failed', giftErr);
                  giftWarning =
                    'Your subscription was added, but the free gift could not be applied. Please review your cart.';
                });
            })
            .then(function () {
              openCart();
              if (giftWarning) alert(giftWarning);
              if (!giftItems.length) return;
              // Late EG clean-up in the background so the bag opens right away.
              removeExtraGifts(
                giftVariantIds,
                beforeGiftKeys,
                beforeQtyByKey,
                nonce,
                giftAddQty
              ).catch(function (err) {
                console.error('[clc-ec-page01ads] Gift clean-up failed', err);
              });
            });
        });
      }

      var job;
      if (plan === 'sub' && sellingPlanId) {
        if (skipGift) {
          job = addSubscriptionOnly();
        } else {
          job = addSubscriptionWithGift().catch(function (err) {
            console.error('[clc-ec-page01ads] Kaching gift ATC failed, falling back to product only', err);
            // Stay silent only when no deal / no gift is set up for this product.
            var silent =
              err &&
              /subscription offer is unavailable|No Kaching deal bar found|No subscription gift found for this offer/i.test(
                String(err.message || '')
              );
            return addSubscriptionOnly().then(function () {
              if (!silent) {
                alert(
                  'Your subscription was added, but the free gift could not be applied. Please review your cart.'
                );
              }
            });
          });
        }
      } else {
        job = addOneTime();
      }

      job
        .catch(function (err) {
          console.error('[clc-ec-page01ads] ATC failed', err);
          alert(err && err.message ? err.message : 'Something went wrong. Please try again.');
        })
        .then(resetBusy, resetBusy);
    }

    atcButtons(root, satc).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-clc-ec-page01ads]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var root = e.target.querySelector('[data-clc-ec-page01ads]') || e.target;
    if (root && root.hasAttribute && root.hasAttribute('data-clc-ec-page01ads')) {
      root.dataset.clcReady = '';
      initRoot(root);
    }
  });
})();
